import axios from "axios"
import AppRouter from "../AppRouter"
import StoreAdapter from "../store/StoreAdapter"
import { Storage } from "../util"
import Environment from "../services/Environment"

const controller = "/usuario"

const UsuarioService = {
    login: async (username, password) => {
        let params = {
            username,
            password,
            grant_type: "password"
        }
        let body = []
        for (let property in params) {
            let encodedKey = encodeURIComponent(property)
            let encodedValue = encodeURIComponent(params[property])
            body.push(encodedKey + "=" + encodedValue)
        }
        body = body.join("&")
        const options = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Authorization": "Basic Y2xpZW50YXBwOjEyMzQ1"
            },
        }
        const { data } = await axios.post(`oauth/token`, body, options)
        if (data.access_token) {
            const usuario = {
                token: data.access_token,
                usu_id: data.id_usuario,
                usu_nombre: data.usu_nombre,
                usu_nombre_completo: data.usu_nombre_completo,
                pry_id: data.pry_id,
                usu_nivel: data.usu_nivel,
                roles: data.roles.split(","),
                usu_correo: data.usu_correo,
                opciones: data.opciones ? data.opciones.split(",") : null,
                modulos: data.modulos ? data.modulos.split(",") : null,
                app_version: Environment.version
            }
            StoreAdapter.dispatch(StoreAdapter.modules.UsuarioStore.actions.setUsuario, usuario)
            return true
        } else {
            return false
        }
    },
    logout: () => {
        StoreAdapter.dispatch(StoreAdapter.modules.UsuarioStore.actions.removeUsuario)
        // Pare remover los datos del usuario
        Storage.remove("usuario")
        Storage.remove("estados")
        Storage.remove("tipos_producto")
        Storage.remove("marcas")
        Storage.remove("unidades_medida")
        Storage.remove("almacenes")
        Storage.remove("categorias")
        Storage.remove("condiciones_comerciales")
        // Para remover los datos como almacenes, estados, etc
        Storage.remove("data")
        AppRouter.push({
            name: "Login"
        })
    },
    cambiarContraseña: async (request) => {
        const { data } = await axios.post(`${controller}/changePassword`, request)
        return data
    },
    getUsuario: () => {
        return Storage.getObject("usuario")
    },
    verificarRoles: (...roles) => {
        let coincidences = 0
        UsuarioService.getUsuario().roles.forEach(rol1 => {
            roles.forEach(rol2 => {
                if (rol1 == rol2.rol_nombre) {
                    coincidences++
                }
            })
        })
        return coincidences != 0
    },
    registrar: async (usuario) => {
        const { data } = await axios.post(`${controller}/registrar`, {
            usuario
        })
        return data
    },
    obtener: async (usuario) => {
        const { data } = await axios.post(`${controller}/obtener`, {
            usuario
        })
        return data
    },
    remove: () => {
        StoreAdapter.dispatch(StoreAdapter.modules.UsuarioStore.actions.removeUsuario)
        Storage.remove("usuario")
    },
    buscar: async (request) => {
        const { data } = await axios.post(`${controller}/buscar`, request)
        return data
    },
    modificar: async (request) => {
        const { data } = await axios.post(`${controller}/modificar`, request)
        return data
    },
    adjuntarFirma: async (request) => {
        let form = new FormData()
        form.append("firma", request.firma)
        form.append("usu_id", request.usu_id)
        const { data } = await axios.post(`${controller}/adjuntarFirma`, form)
        return data
    },
    isCoorporative: () => {
        return UsuarioService.getUsuario() ? UsuarioService.getUsuario().usu_nivel == 1 : false
    },
    getProject: () => {
        return UsuarioService.getUsuario().pry_id
    },
    checkAppVersion: () => {
        // info
        // Este metodo verifica que version tiene el cliente 
        // contra que version ha sido publicada en produccion
        if (UsuarioService.getUsuario() != null
            && UsuarioService.getUsuario().app_version) {
            if (UsuarioService.getUsuario().app_version != Environment.version) {
                UsuarioService.logout()
            }
        } else {
            UsuarioService.logout()
        }
    }
}

export default UsuarioService